<div class="InfoDetails">
        <div class="Loading"  *ngIf="isShowLoading==true">
                <img id="" src="assets/img/762.gif"   />
                <label>{{'Please Wait,Processing..'}}</label>
        </div> 

    <div class="Clears"></div>

    <!-- <div class="row form-group hidden-sm hidden-xs">
            <div class="row bs-wizard RenMotoWizard" style="border-bottom:0;">
                
                    <div class="col-xs-4 bs-wizard-step complete">
                      <div class="text-center bs-wizard-stepnum">{{'Step 1' | translate }}</div>
                      <div class="progress"><div class="progress-bar"></div></div>
                      <a href="#" class="bs-wizard-dot"></a>
                      <div class="bs-wizard-info text-center">{{'Basic Info.' | translate }}</div>
                    </div>
                    
                    <div class="col-xs-4 bs-wizard-step "  [ngClass]="!ReviewInfo?'complete':'active'">
                      <div class="text-center bs-wizard-stepnum">{{'Step 2' | translate }}</div>
                      <div class="progress"><div class="progress-bar"></div></div>
                      <a href="#" class="bs-wizard-dot"></a>
                      <div class="bs-wizard-info text-center"> {{'Insured' | translate }} & {{'Driver Details' |translate }}</div>
                    </div>
                    
                    <div class="col-xs-4 bs-wizard-step "  [ngClass]="ReviewInfo?'disabled':'complete'">
                      <div class="text-center bs-wizard-stepnum">{{'Step 3' | translate }}</div>
                      <div class="progress"><div class="progress-bar"></div></div>
                      <a href="#" class="bs-wizard-dot"></a>
                      <div class="bs-wizard-info text-center"> {{'Review'| translate }} & {{'Payment' | translate}}</div>
                    </div>
                    
                     
                </div>

        </div> -->
        <!-- <h1>It works</h1> -->

    <div class="row">

        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">

              
            <router-outlet></router-outlet>

        </div>



        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">


            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding:0px;">
                <div class="card" style="width:100%;" id="InsuredInfo">
                    <ul class="nav nav-tabs listdata" role="tablist">
                        <li role="presentation" class="active">
                            <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Policy Info' | translate }}</a>
                        </li>

                    </ul>

                    <div class="tab-content detailsTab">
                        <div role="tabpanel" class="tab-pane active" id="home">
                            <div class="card" style="width:100%;">
                                <ul class="nav nav-tabs Sublistdata" role="tablist">
                                    <li role="presentation" class="active">
                                        <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Policy Period Information' | translate }}</a>
                                    </li>

                                </ul>
                                <div class="tab-content">
                                    <div role="tabpanel" class="tab-pane active PolicyInfo" id="PolicyInfo">

                                        <label>
                                            <span class="lbltext">{{'Starting' | translate  }}:</span>
                                            <!-- <span> {{prObj.ProposalEffFrom | date:'d/M/y' }}</span> -->
                                            <span> {{ objPremiumAndVehicleInfoRes.VEHICLE_INFO.PROPOSAL_EFFECTIVEDATE | date:'d/M/y' }}</span>
                                        </label>
                                        <label>
                                            <span class="lbltext">{{'Ending' | translate }}:</span>
                                            <!-- <span>{{prObj.ProposalEffTo  | date:'d/M/y' }}</span> -->
                                            <span> {{objPremiumAndVehicleInfoRes.VEHICLE_INFO.PROPOSAL_EXPIRYDATE | date:'d/M/y' }}</span>

                                        </label>
                                    </div>

                                </div>
                            </div>
                            <div class="card" style="width:100%;">
                                <ul class="nav nav-tabs Sublistdata" role="tablist">
                                    <li role="presentation" class="active">
                                        <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Vehicle Information' | translate }}</a>
                                    </li>

                                </ul>
                                <div class="tab-content">

                                    <div role="tabpanel" class="tab-pane active PolicyInfo" id="home">

                                        <label>
                                            <span class="lbltext">{{'Use Of Vehicle' | translate }}:</span>
                                            <!-- <span>{{prObj.Vechile.UseOfVehcileEn}}</span> -->
                                            <span> {{ Lng=="en" ? objPremiumAndVehicleInfoRes.VEHICLE_INFO.VEHICLE_USAGE_EN: objPremiumAndVehicleInfoRes.VEHICLE_INFO.VEHICLE_USAGE_AR }}</span>
                                        </label>
                                        <label>
                                            <span class="lbltext">{{'Plate No Arabic' | translate }}:</span>
                                            <!-- <span>{{prObj.Vechile.VehicleFullPlateNoAr}}</span> -->
                                            <span> {{ objPremiumAndVehicleInfoRes.VEHICLE_INFO.VEHICLE_FULLPLATENOAR }}</span>
                                        </label>
                                        <label>
                                            <span class="lbltext">{{'Plate Type' | translate }}:</span>
                                            <!-- <span>{{prObj.Vechile.PlateTypeEn}}</span> -->
                                            <span> {{ Lng=="en"? objPremiumAndVehicleInfoRes.VEHICLE_INFO.PLATE_TYPE_EN: objPremiumAndVehicleInfoRes.VEHICLE_INFO.PLATE_TYPE_AR }}</span>
                                        </label>
                                        <label>
                                            <span class="lbltext">{{'vehicle Type' | translate }}:</span>
                                            <!-- <span>{{prObj.Vechile.VechTypeEn}}</span> -->
                                            <span> {{ Lng=="en" ? objPremiumAndVehicleInfoRes.VEHICLE_INFO.VEHICLE_TYPE_EN: objPremiumAndVehicleInfoRes.VEHICLE_INFO.VEHICLE_TYPE_AR }}</span>
                                        </label>
                                        <label>
                                            <span class="lbltext">{{'Make' | translate }}:</span>
                                            <!-- <span>{{prObj.Vechile.VechileMakeEn}}</span> -->
                                            <span>{{ Lng=="en" ? objPremiumAndVehicleInfoRes.VEHICLE_INFO.MAKE_DESC_EN: objPremiumAndVehicleInfoRes.VEHICLE_INFO.MAKE_DESC_AR  }}</span>
                                        </label>
                                        <label>
                                            <span class="lbltext">{{'Model' | translate }}:</span>
                                            <!-- <span>{{prObj.Vechile.VechileModelEn}}</span> -->
                                            <span>{{ Lng=="en" ? objPremiumAndVehicleInfoRes.VEHICLE_INFO.MODEL_DESC_EN: objPremiumAndVehicleInfoRes.VEHICLE_INFO.MODEL_DESC_AR }}</span>
                                        </label>
                                        <label>
                                            <span class="lbltext">{{'ManufactureYear' | translate }}:</span>
                                            <!-- <span>{{prObj.Vechile.VehicleManfYear}}</span> -->
                                            <span>{{ objPremiumAndVehicleInfoRes.VEHICLE_INFO.VEHICLE_MANFYEAR }}</span>
                                        </label>
                                        <label>
                                            <span class="lbltext">{{'vehicle Color' | translate }}:</span>
                                            <!-- <span>{{prObj.Vechile.VehicleColor}}</span> -->
                                            <span>{{ objPremiumAndVehicleInfoRes.VEHICLE_INFO.VEHICLE_COLOR }}</span>
                                            
                                        </label>

                                    </div>

                                </div>
                            </div>

                            <div class="card" style="width:100%;">
                                <ul class="nav nav-tabs Sublistdata" role="tablist">
                                    <li role="presentation" class="active">
                                        <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Insured Licence Information' | translate }}</a>
                                    </li>

                                </ul>
                                <div class="tab-content">
                                    <div role="tabpanel" class="tab-pane active PolicyInfo" id="home">


                                        <label>
                                            <span class="lbltext">{{'Name' | translate }}:</span>
                                            <!-- <span>{{ prObj.InsuredName}}</span> -->
                                            <span>{{ objPremiumAndVehicleInfoRes.VEHICLE_INFO.INSURED_NAME }}</span>
                                        </label>
                                        <label>
                                            <span class="lbltext">{{'Licence Expiry Date' | translate }}</span>
                                            <!-- <span>{{prObj.InsuredDriverLicIssueDateAr }}</span> -->
                                            <span>{{ objPremiumAndVehicleInfoRes.VEHICLE_INFO.INSURED_LICENCE_EXPIRY }}</span>
                                        </label>



                                    </div>

                                </div>
                            </div>




                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/CompRenewalProposal/CompRenewalProposal.html